module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/modules/_library.js
// module id = 226
// module chunks = 0